<template>
  <span>
    <v-list-item
      :href="href"
      :rel="href && href !== '#' ? 'noopener' : undefined"
      :target="href && href !== '#' ? '_blank' : undefined"
      :to="!item.disabled ? item.to : null"
      :active-class="`primary ${!isDark ? 'black' : 'white'}--text`"
      :id="idElement"
  
      @click="setTipolistaConsulta(item)"
    >
      <v-list-item-icon
        v-if="item.icon"
        class="v-list-item__icon--text"
      >
        <v-icon v-text="item.icon" :disabled="item.disabled" />
      </v-list-item-icon>
  
      <v-list-item-icon
        v-else-if="text"
        class="v-list-item__icon--text"
        :prepend-icon="item.icon"
        v-text="computedText"
      />
  
      <v-list-item-icon
        v-else-if="item.sigla"
        class="v-list-item__icon--text"
        v-text="item.sigla"
      />
  
      <v-list-item-icon v-else-if="item.icon">
        <v-icon v-text="item.icon" />
      </v-list-item-icon>
  
      <v-list-item-content v-if="item.title || item.subtitle">
        <v-list-item-title v-text="item.title" />
  
        <v-list-item-subtitle v-text="item.subtitle" />
      </v-list-item-content>
    </v-list-item>
  <ferramenta-inativa-dialog
    v-if="item.disabled && dialogDisabled.released"
    :dialog.sync="dialogDisabledManager"
  >
    <span slot="text" v-html="dialogDisabled.msg" />
  </ferramenta-inativa-dialog>
  </span>
</template>

<script>
  import Themeable from 'vuetify/lib/mixins/themeable'

  export default {
    name: 'Item',

    components: {
      FerramentaInativaDialog: () => import('@/components/general/FerramentaInativaDialog')
    },

    mixins: [Themeable],

    props: {
      idElement: {
        type: String,
        default: "base-item"
      },
      item: {
        type: Object,
        default: () => ({
          href: undefined,
          icon: undefined,
          subtitle: undefined,
          title: undefined,
          to: undefined,
        }),
      },
      text: {
        type: Boolean,
        default: false,
      },
      dialogDisabled: {
        type: Object,
        default: () => ({released: false, msg: ''}),
        required: false
      }
    },

    data: () => ({
      dialogDisabledManager: false
    }),

    computed: {
      computedText () {
        if (!this.item || !this.item.title) return ''

        let text = ''

        this.item.title.split(' ').forEach(val => {
          text += val.substring(0, 1)
        })

        return ''
      },
      href () {
        return this.item.href || (!this.item.to ? '#' : undefined)
      },
    },

    methods:{
      setTipolistaConsulta(item) {
        if (item.disabled) {
          this.dialogDisabledManager = true;
          return false;
        }

        if(item.title == 'Relatórios'){
          this.$store.dispatch('setTipolistaConsulta', 'historico');
        }
      }
    }
  }
</script>
